namespace app.model.tiffing {
  export class TiffBatch implements ITiffBatch {
    public id: string;
    public projectId: string;

    public status: TiffBatchStatus;
    public job: app.model.job.TiffBatchJob;

    public name: string;

    constructor(id: string, projectId: string, name: string, percentageComplete: number) {
      this.id = id;
      this.projectId = projectId;
      this.name = name;
      this.job = new app.model.job.TiffBatchJob(percentageComplete);
    }
  }
}
